const menu = {
    label: 'Eventos',
    icon: 'pi pi-fw pi-calendar',
    to: '/checkins/eventos',
    matchChildren: true,
    rules: ['CHECKINS-EVENTOS-00'],
};

export default menu;
